export default "__VITE_ASSET__CVEpP3pu__"